import React, { useState, useEffect, useRef } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import {optionProductsByProducts} from '../Options';
import Sidebar from '../Sidebar';
import Multiselect from 'multiselect-react-dropdown';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
export default function PriceForm() {
 
    const [date, setDate] = useState('2023-08-09')
    const [product_id, setProductID] = useState()
    const [product, setProduct] = useState()
    const [by_product_id, setByProductID] = useState()
    const [by_product, setByProduct] = useState()
    const [province_id, setProvinceID] = useState()
    const [province, setProvince] = useState()
    const [district_id, setDistrictID] = useState()
    const [district, setDistrict] = useState()
    const [station_id, setStationID]= useState()
    const [station, setStation] = useState()
    const [minimum, setMinimum] = useState()
    const [maximum, setMaximum]= useState()
    const [arrivals, setArrivals] = useState()
    //Arrivals units
    const [arrivalsUnit, setArrivalsUnit] = useState()
    //for single serarch
    const [search, setSearch] = useState('')
    //options
    const [selectedOptions, setSelectedOptions] = useState([])
    //min-max states
    const [check, setCheck] = useState(false)
    const [message, setMessage] = useState('')
    const [displayMessage, setDisplayMessage] = useState(false)
    //province items
    const [options, setOptions] = useState([])
    //new
    const [displayAlert, setDisplayAlert] = useState(false)
    const [sSubmit, setSSubmit]= useState('')
    const [pSubmit, setPSubmit] = useState('')
    //references
    const byproductRef = useRef(null)
    const stationRef = useRef(null)
    const minRef = useRef(null)
    const maxRef = useRef(null)
    const arrivalsRef = useRef(null)
    //Navigation
    const navigate = useNavigate()

    // Set the default value to today's date in "YYYY-MM-DD" format
    useEffect(() => {
      const today = new Date().toISOString().split('T')[0];
      setDate(today);
    }, []);


    //resetting form
    const reset = () =>{
      byproductRef.current.value = ''
        stationRef.current.resetSelectedValues()
        minRef.current.value=''
        maxRef.current.value=''
        arrivalsRef.current.value=''
        setDate('2023-08-09');
        setProductID(null);
        setProduct(null);
        setByProductID(null);
        setByProduct(null);
        setProvinceID(null);
        setProvince(null);
        setDistrictID(null);
        setDistrict(null);
        setStation(null);
        setStationID(null);
        setMinimum(null);
        setMaximum(null);
        setArrivals(null)
    }
    //reset date
    const resetDate = () => {
      const today = new Date().toISOString().split('T')[0];
      setDate(today);
    };

    const token = sessionStorage.getItem('token')
    const ferrit = async() =>{
      
      if(token){
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/stations`, {
        headers: {
          'x-access-token': token
        }
      })
      console.log("Got the data")
      const data = await response.json()
      console.log(data)
      setOptions(data)
      }
      else{
        console.log("No token!")
      }
    }

    useEffect(()=>{
      ferrit()
    },[])

    //function for min-max
    const minMax = () => {
      if (minimum !== null && maximum !== null && minimum !== '' && maximum !== '') {
        if (Number(minimum) > Number(maximum)) {
          setMessage('Minimum cannot be greater than maximum');
          setDisplayMessage(true)
          setCheck(false);
        } else {
          setDisplayMessage(false)
          setCheck(true);
        }
      } else {
        setCheck(false);
      } 
    };    

    useEffect(() => {
      minMax()
    }, [minimum, maximum])


    //handler for product-byproduct
    const handleSelectChange = (event) => {
      const selectedName = event.target.value;
      // Find the selected option based on its name
      const selectedOption = optionProductsByProducts.find(option => option.name === selectedName);
    
      // Ensure that the selectedOption is valid before setting state
      if (selectedOption) {
        setByProduct(selectedOption.name); 
        setByProductID(selectedOption.value); 
        setProduct(selectedOption.product);
        setProductID(selectedOption.product_id);
      } else {
        console.log("Selected option not found!");
      }
    };
    

    // Use useEffect to log the state whenever the state variables change
    useEffect(() => {
      console.log(product + " " + by_product + " " + product_id + " " + by_product_id);
    }, [product, by_product, product_id, by_product_id]);
        

    const handleMinimumChange = (e) =>{
        setMinimum(parseFloat(e.target.value))
        console.log(minimum)
    }

    const handleMaximumChange = (e) => {
        setMaximum(parseFloat(e.target.value))
        console.log(maximum)
    }

    const handleBatchChange =(e) =>{
      setArrivals(parseFloat(e.target.value))
      console.log(arrivals)
    }
    //new
    const smessage = (station, byproduct) =>{
        setSSubmit(station)
        setPSubmit(byproduct)
    }


    const handleSubmit = (e) => {
      e.preventDefault();

      if(selectedOptions.length < 1){
        alert("Select a station before submitting.")
        return
      }

      const variables = [ date, product_id,product,by_product_id,by_product, selectedOptions, minimum,maximum 
    ];
      if (variables.every((variable) => typeof variable === 'undefined')) {
        return alert('No field should be empty');
      } 

      if (variables.some((variable) => typeof variable === 'undefined')) {
        return alert('No field should be empty 2')
      } 

  
      //Insert submitters name
      const token = sessionStorage.getItem("token")
      const user = jwtDecode(token)

        const prices = selectedOptions.map((option) => ({
          date,
          product_id,
          product,
          by_product_id,
          by_product,
          province_id: option.province_id,
          province: option.province,
          district_id: option.district_id,
          district: option.district,
          station_id: option.value,
          station: option.name,
          minimum,
          maximum,
          arrivals,
          arrivalsUnit,
          user_name:user.userName
        }));
        console.log("Here are my prices", prices)
        
    
      fetch(`${process.env.REACT_APP_API_URL}/admin/prices`, {
        
        method: 'POST',
        headers: {
          "Content-Type" : "application/json",
          "x-access-token":token
        },
        body: JSON.stringify(prices)
      }).then(() => {
        navigate('/prices')
       
      }).catch((err) => {
        console.log("Unable to add record" + err);
      });
    };
    
    //dealing with multiple states
    const handleSelectStateOptions =  (selectedList)=>{
      setSelectedOptions(selectedList)
    }
    useEffect(()=>{
      console.log(selectedOptions)
    },[selectedOptions])

  return (
<>
<div className="sidebar">
      <Sidebar/>
      </div>
<div className="row">
  <div className="col">
  <div style={{position:"center"}}>
<form onSubmit={handleSubmit} className='needs-validation' >

<div class="mb-3" id='tabler'>
  <h1>Cotton Price</h1>

<div className="row">
<div className="col-md-6">
    <div>
      <div className="mb-3" >
        <label htmlFor="date" className="form-label">
          Date
        </label>
        <input
          id="num-value"
          type="date"
          className="form-control"
          min="0"
          required
          value={date || ""}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      {/* Rest of your form */}
    </div>
    </div>

    <div className="col-md-6">
    <label for="formGroupExampleInput2" class="form-label">Station</label>
            <Multiselect 
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
              ref={stationRef}
            />
    </div>
</div>

 
    <div className="row">
 {/**By product dropdown */}
 <div className='col-md-6'>
      <label for="exampleFormControlTextarea1" class="form-label" >By Product</label>
      <div className="input-group mb-3"  >
        <select className="form-select" id="inputGroupSelect04" aria-label="Example select with button addon" onChange={handleSelectChange} ref={byproductRef}required >
          <option value="">By Product</option>
          {optionProductsByProducts.map((optionProductsByProduct) => (
            <option key={optionProductsByProduct.value} value={optionProductsByProduct.name}>
              {optionProductsByProduct.name}
            </option>
          ))}
        </select>
      </div>

      </div>

      
      {/**Batches */}
      <div className='col-md-6' >
        <div className="mb-3" >
          <label for="number" className="form-label">
            Arrivals
          </label>
          <input id="num-value"type="number" className="form-control" min="0" onChange={handleBatchChange} ref={arrivalsRef}/>
        </div>
      </div>
    </div>
   
           
            {/* Render the filteredPrices here */}
            {/* You can use the filteredPrices state to display the filtered data */}
         
     <div className="row" >
      {/**Minimum Price */}
      <div className='col-md-6'>
        <div className="mb-3" >
          <label for="number" className="form-label">
            Minimum
          </label>
          <input id="num-value"type="number" className="form-control" min="0" onChange={handleMinimumChange} required ref={minRef}/>
        </div>
      </div>

      {/**Maximum Price */}
      <div className='col-md-6'>
        <div className="mb-3" >
          <label for="number" className="form-label">
            Maximum
          </label>
          <input id="num-value"type="number" aria-describedby="Value should not be less than 0" className="form-control" min="0" onChange={handleMaximumChange} ref={maxRef}required/>
        </div>
      </div>
     </div>


     <div className="row" >
      {/**Minimum Price */}
      <div className='col-md-6'>
        <div className="mb-3" >
          <label for="number" className="form-label">
            Arrivals Unit
          </label>
          <input id="num-value"type="number" className="form-control" min="0" onChange={(e)=>setArrivalsUnit(e.target.value)} ref={minRef}/>
        </div>
      </div>

     </div>
         
          </div>
       





            
{/**Submit Button */}
{check && <button type="submit" id ="button-submit" className="btn submit-btn">Submit</button>}
{/**Error if min and max values are not agreeing */}
{displayMessage && <div class="alert alert-danger" id ="button-submit"role="alert">
      Minimum value cannot be greate than maximum value
</div>}
    </form>
    
</div>
  </div>
</div>

</>
    
  );
}
